module.exports = __webpack_public_path__ + "img/master_logo.e94d8d24.png";